export default __webpack_public_path__ + "static/media/close.825cd3c2.svg";